import { RNG } from "rot-js"

export function generateRandomNumber(min: number, max: number): number {
  return Math.floor(RNG.getUniform() * (max - min + 1) + min)
}

export function generateRandomNumberZeroToOne(): number {
  return RNG.getUniform()
}
